(() => {
  if (window.iGardenNewsletterProxyInitialized) return;
  window.iGardenNewsletterProxyInitialized = true;

  const endpoint = '/apps/knowledge/newsletter.json';

  async function subscribe(container) {
    if (container.dataset.newsletterSubmitting === 'true') return;

    const emailInput = container.querySelector('input[type="email"]');
    const submitButton = container.querySelector('[data-newsletter-submit], [type="submit"]');
    const successMessage = container.querySelector('[data-newsletter-success]');
    const errorMessage = container.querySelector('[data-newsletter-error]');
    const source = container.dataset.newsletterSource || '';
    const tags = (container.dataset.newsletterTags || '').split(',').map((tag) => tag.trim()).filter(Boolean);

    if (!emailInput || !submitButton || !emailInput.reportValidity()) return;

    container.dataset.newsletterSubmitting = 'true';
    container.setAttribute('aria-busy', 'true');
    submitButton.disabled = true;
    if (successMessage) successMessage.hidden = true;
    if (errorMessage) errorMessage.hidden = true;

    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ email: emailInput.value.trim(), source, tags })
      });
      const result = await response.json();

      if (!response.ok || result.ok !== true) throw new Error('Newsletter subscription failed');

      emailInput.value = '';
      if (successMessage) successMessage.hidden = false;
    } catch (_) {
      if (errorMessage) errorMessage.hidden = false;
    } finally {
      submitButton.disabled = false;
      container.removeAttribute('aria-busy');
      delete container.dataset.newsletterSubmitting;
    }
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('[data-newsletter-submit]');
    const container = button?.closest('[data-newsletter-proxy]');
    if (!container) return;

    event.preventDefault();
    subscribe(container);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' || event.isComposing || event.target.type !== 'email') return;
    const container = event.target.closest?.('[data-newsletter-proxy]');
    if (!container || container.tagName === 'FORM') return;

    event.preventDefault();
    subscribe(container);
  });

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-newsletter-proxy]')) return;

    event.preventDefault();
    subscribe(form);
  });
})();
